module.exports = __webpack_public_path__ + "static/media/newdefaultprofilepicture.e6e20cc1.png";